<template>
  <div class="email-signup">
    <div v-show="!submitted">
      <div
        :class="{ 'has-error': $v.email.$error }"
        class="form-group">
        <div class="input-group input-group-sm">
          <input
            v-model.trim="email"
            type="email" 
            class="form-control"
            placeholder="Enter your email Address"
            required
            @keyup.enter="submit">
          <div class="input-group-btn">
            <button
              class="btn btn-default"
              @click="submit">
              Go
            </button>
          </div>
        </div>
        <span
          v-show="$v.email.$error"
          class="help-block">
          Please enter a valid email.
        </span>
      </div>
      <div class="clearfix"/>
      <div>
        <div class="consent">
          <a href="/help/privacy_security.cfm">Terms and Conditions</a>
        </div>
      </div>
    </div>
    <div
      v-show="submitted"
      v-html="message"/>
  </div>
</template>

<style scoped>
.email-signup {
  width: 100%;
}
.form-group {
  margin-bottom: 0;
}

.consent {
  font-size: 10px;
  margin-top: 4px;
  text-transform: none;
}

.consent a {
  text-decoration: underline;
}

.consent input {
  margin: 0;
  vertical-align: middle;
}

@media (min-width: 480px) {
  div.input-group {
    max-width: 100%;
  }

  .email-signup {
    width: 250px;
  }
}
</style>

<script>
import axios from 'axios'
import { required, email } from 'vuelidate/lib/validators'
import { jrNotifyEx } from '../bootstrap'
import { leadConversion } from '../module/util'

export default {
  props: {
  },

  data () {
    return {
      email: null,
      submitted: 0,
      message: 'Processing...'
    }
  },

  validations: {
    email: {
      required,
      email
    }
  },

  methods: {
      submit: async function () {
        try {
          this.$v.$touch()
          if (!this.$v.$error) {
            this.submitted = 1
            const response = await axios.post("/promo/email-signup", {
              email: this.email
            })
            if (response.success || (response.data && response.data.success)) {
              leadConversion("email_signup")
              this.message = "Thanks for signing up!"
            } else if (response.error && response.error.message) {
              this.message = response.error.message
            } else {
              this.message = "We couldn't process your request. Try again later."
            }
          }
        } catch (e) {
          const data = e.response ? (e.response.data || {}) : {}
          if (e.response && e.response.status == 422 && data.email) {
            this.message = data.email.join("<br>")
          } else if (data.error && data.error.message) {
            this.message = data.error.message
          } else {
            this.message = "We couldn't process your request. Try again later."
            jrNotifyEx(e, e.response)
          }
        }
      },
  }
}
</script>
